<template>
   <div class="formButtonSubmit">
      <button
         type="button"
         class="loginbtn primaryBtn"
         v-bind="$attrs"
         v-on="$listeners"
         >
      {{ buttonText }}
      </button>
   </div>
</template>
<script>
export default {
  props: {
    // Propiedad para el texto del botón
    buttonText: {
      type: String,
      default: 'Enviar', // Texto predeterminado
    },
  },
  methods: {
    // Método que emite un evento al hacer clic en el botón
    handleClick () {
      this.$emit('click')
    },
  },
}
</script>